export default __webpack_public_path__ + "static/1_2-6cc1185463b32621539ef84b89a748b6.jpg";